import { ShareModel } from '@/Models/Share/ShareModel';

export class ShareState {
  constructor() {
    /** @type {ShareModel[]} */
    this.list = [];
  }
}
